import { combineReducers } from 'redux'
import PatientsBirthdateChangeReducer from "./patients.birthdate.change.reducer";
import PatientsBirthdateDateReducer from "./patients.birthdate.date.reducer";

const PatientsBirthdateReducer = combineReducers({
  date: PatientsBirthdateDateReducer,
  change: PatientsBirthdateChangeReducer,
})

export default PatientsBirthdateReducer